// extracted by mini-css-extract-plugin
export default {"heading":"Boilers_heading__T6aw3"};